<template>
  <div class="container-fluid">
    <vx-card title="Campañas de correo: Analíticas">
      <h6 class="card-subtitle text-muted">Analytics de campañas</h6>

      <div class="row">
        <div class="col-7">
          <vs-table :data="campaigns" :max-items="5" stripe search pagination>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Nombre de campaña</vs-th>
              <vs-th>Audiencia</vs-th>

              <vs-th>Universe</vs-th>
              <vs-th>Rebound</vs-th>
              <vs-th>Delivered</vs-th>
              <vs-th>Opened</vs-th>
              <vs-th>Clicked</vs-th>
              <vs-th>Spam</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(campaign, index) in data" :key="index">
                <vs-td>{{campaign.id}}</vs-td>
                <vs-td>
                  <vs-button @click.stop="chargeSourceChart(campaign.id)" size='small'>{{campaign.name}}
                  </vs-button>
                </vs-td>
                <vs-td>{{campaign.audience_id}}</vs-td>
                <vs-td>{{campaign.universe}}</vs-td>

                <vs-td>{{campaign.rebound}}</vs-td>
                <vs-td>{{campaign.delivered}}</vs-td>
                <vs-td>{{campaign.opened}}</vs-td>
                <vs-td>{{campaign.clicked}}</vs-td>
                <vs-td>{{campaign.spam}}</vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>

        <div class="col-5">
          <div id="chartContainer" style="height: 370px; width: 100%;"></div>
        </div>

      </div>
    </vx-card>

  </div>
</template>

<script>
  export default {
    name: "Analytics",
    data: () => ({
      campaigns: [],
    }),
    async mounted() {
      this.startLoading();
      //Libraries 3d Party
      let externalScript = document.createElement('script');
      externalScript.setAttribute('src', 'https://canvasjs.com/assets/script/canvasjs.min.js');
      document.head.appendChild(externalScript);
      await axios.get(`/api/app-http-services/services/notifications/email/campaigns`)
        .then(response => {
          this.campaigns = response.data;
          if (this.campaigns.length > 0) {
            this.chargeSourceChart(this.campaigns[0].id);
          }
          return response.data;
        });
      this.stopLoading();
    },
    methods: {
      chargeSourceChart(campaign_id) {
        let campaign = this.campaigns[this.campaigns.map(c => c.id).indexOf(campaign_id)];
        let chart = new CanvasJS.Chart("chartContainer", {
          animationEnabled: true,
          exportEnabled: true,
          theme: "light2", // "light1", "light2", "dark1", "dark2"
          title: {
            text: `#${campaign_id} ${campaign.name}`
          },
          axisY: {
            includeZero: true
          },
          data: [{
            type: "column", //change type to bar, line, area, pie, etc
            indexLabel: "{title}", //Shows y value on all Data Points
            indexLabelFontColor: "#5A5757",
            indexLabelFontSize: 16,
            indexLabelPlacement: "outside",
            dataPoints: [{
                x: 1,
                title: 'rebound',
                y: campaign.rebound
              },
              {
                x: 2,
                title: 'delivered',
                y: campaign.delivered
              },
              {
                x: 3,
                title: 'opened',
                y: campaign.opened
              },
              {
                x: 4,
                title: 'clicked',
                y: campaign.clicked
              },
              {
                x: 5,
                title: 'spam',
                y: campaign.spam
              }
            ]
          }]
        });
        chart.render();
      },
    },
  }
</script>